import { Injectable, inject } from '@angular/core';
import { Observable, throwError, map, tap } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IAccountDeregQueue } from '../../interfaces/account-dereg-queue';
import { IAccountDeregQueueResponse } from '../../interfaces/account-dereg-queue-response';
// import { AppConfigService} from '../../services/app-config.service';
import { environment } from '../../../environments/environment';
import { ErrorProcessorService }  from "../../shared/services/error-processor.service";
import { SharedService }  from "../../shared/services/shared.service";
import { IMyArtifact } from '../../interfaces/my-artifact';

@Injectable({
  providedIn: 'root'
})
export class AccountDeregQueueService {

  private readonly http = inject(HttpClient);

  private readonly errorProcessorService = inject(ErrorProcessorService);
  private readonly sharedService = inject(SharedService);

  protected portalBaseUrl = environment.apiServer.portalUrl;  

  private accountsOnDeathRowUrl = "/account-dereg-queue?brandCode={brandCode}&offset={offset}&limit={limit}&status={status}";  
  private artifactsUrl = "/artifacts";

  constructor() { }

  // findAccountsInDeregQueue(brandCode: string, offset: number, limit: number, baseUrl: string, 
  //     accountNo?: string | undefined, status?: string | undefined, 
  //     dateStart?: string | undefined, dateEnd?: string | undefined):
  //      Observable<{data: IAccountDeregQueue[]; totalCnt: number}>{
  //   var url = baseUrl.replace('Walletron','reports') + this.accountsOnDeathRowUrl
  //     .replace('{brandCode}', brandCode)
  //     .replace('{status}', status ? status : 'D,R,G,X')
  //     .replace('{offset}', offset.toString())
  //     .replace('{limit}', limit.toString());
  //   if (accountNo) {
  //     url += "&accountNo=" + accountNo + '%';
  //   }
  //   if (dateStart) {
  //     url += "&dateStart=" + dateStart;
  //   }
  //   if (dateEnd) {
  //     url += "&dateEnd=" + dateEnd;
  //   }
  //   return this.http.get<IAccountDeregQueue[]>(url, {observe: 'response', responseType: 'json'})
  //   .pipe(
  //      tap(resp => {
  //         console.log('--- Full HTTP Response ---');
  //         console.log(resp);
  //       }),
  //       map(resp => {
  //         console.log('--- Angular-visible headers ---');
  //         resp.headers.keys().forEach(k => console.log(k, '=>', resp.headers.get(k)));
  //         const totalHeader = resp.headers.get('X-Total-Count') ?? resp.headers.get('x-total-count');
  //         console.log('totalHeader', totalHeader);
  //         const total = totalHeader ? Number(totalHeader) : 0;
  //         console.log('total', total);
  //         return {
  //           data: resp.body ?? [],
  //           totalCnt: Number.isFinite(total) ? total : 0
  //         };
  //       }),
  //       catchError(this.errorProcessorService.handleError)
  //     );  
  // } 

  findAccountsInDeregQueue(brandCode: string, offset: number, limit: number, baseUrl: string, 
      accountNo?: string | undefined, status?: string | undefined, 
      dateStart?: string | undefined, dateEnd?: string | undefined):
       Observable<IAccountDeregQueueResponse>{
    var url = baseUrl.replace('Walletron','reports') + this.accountsOnDeathRowUrl
      .replace('{brandCode}', brandCode)
      .replace('{status}', status ? status : 'D,R,G,X,U')
      .replace('{offset}', offset.toString())
      .replace('{limit}', limit.toString());
    if (accountNo) {
      url += "&accountNo=" + accountNo + '%';
    }
    if (dateStart) {
      url += "&dateStart=" + dateStart;
    }
    if (dateEnd) {
      url += "&dateEnd=" + dateEnd;
    }
    // console.log('findAccountsInDeregQueue - url', url);
    return this.http.get<IAccountDeregQueueResponse>(url, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  } 


  // Generate a file with all accounts in deregistration queue records based on the given criteria
  public generateFileWithAccountsInDeregQueue(userName: string, emailAddress: string, brandCode: string, status?: string | undefined, 
      accountNo?: string | undefined, dateStart?: string | undefined, dateEnd?: string | undefined): Observable<IMyArtifact>{

    var url = this.portalBaseUrl + this.artifactsUrl;
    var artifactRequest:any = {
      artifactName: "AccountDeregistrationQueue",
      artifactParameters: { 
        // brandSmartSelection: "brandCodes",
        brandCode: brandCode,
        statuses: status ? status : 'D,R,G,X,U',
        dateStart: dateStart ?? null,
        dateEnd: dateEnd ?? null,
        accountNo: accountNo ?? null
      },
      artifactRecipientEmails: [
        emailAddress
      ],
      userName: userName
    }
    return this.http.post<IMyArtifact>(url,  artifactRequest , {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }    

}
